/* global Resources */
'use strict';

const shippingCalculator = {

    elements: {
        $cartWrapper: $('.js-cart')
    },

    selectors: {
        cartBottom: '.js-cart-bottom',
        shippingCalculator: '#shippingCalculator',
    },

    renderShippingCalculator(cart, $dialog) {
        let descriptionValue = '';
        let progressValue = 0;

        if (cart.offeredShippingMethod !== 'NONE') {
            descriptionValue = Resources.FREE_SHIPPING_UNLOCKED;
            progressValue = 100;
        }

        if (cart.approachingDiscounts && cart.approachingDiscounts.length) {
            descriptionValue = cart.approachingDiscounts[0].approachingShippingPriceMessage;
            progressValue = cart.approachingDiscounts[0].approachingShippingPricePercent;
        }

        // if (descriptionValue !== '' && progressValue > 0) {
        const isMiniCart = $dialog.attr('id') === 'mini-cart-modal';
        const checkoutUrl = this.elements.$cartWrapper.attr('data-checkout-url');

        $dialog.find(this.selectors.cartBottom).morphBy({
            id: this.selectors.shippingCalculator,
            squirrellyOptions: {
                description: descriptionValue,
                priceTotal: cart.totals.grandTotal,
                progress: progressValue,
                isMiniCart: isMiniCart,
                checkoutUrl: checkoutUrl
            },
        });
        // }
    }
};

module.exports = {
    renderShippingCalculator: (cart, $dialog) => shippingCalculator.renderShippingCalculator(cart, $dialog)
};